export default "__VITE_ASSET__23f7416f__"